import styled from 'styled-components'

/** Fixed box for sidebar menu icons. The source SVGs declare sizes from 14x12 to 20x20. */
export const NavIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;

  svg {
    max-width: 100%;
    max-height: 100%;
  }
`
